module.exports = __webpack_public_path__ + "img/Phones.09a83c54.png";